import styleInject from './../../externals/style-inject/dist/style-inject.es.js';

var css_248z = "@keyframes PawLoader-module_animatePawLoader__lnrF9 {\n  from {\n    bottom: -10px;\n    opacity: 0;\n  }\n  to {\n    bottom: 0px;\n    opacity: 1;\n  }\n}\n.PawLoader-module_pawLoader__PARo- {\n  position: absolute;\n  animation: PawLoader-module_animatePawLoader__lnrF9 0.5s cubic-bezier(0.69, 0.44, 0.35, 1.3);\n  left: calc(50% - 12px);\n  bottom: 0px;\n}";
var styles = {"pawLoader":"PawLoader-module_pawLoader__PARo-","animatePawLoader":"PawLoader-module_animatePawLoader__lnrF9"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=PawLoader.module.scss.js.map
